import { create } from "zustand";
import { RealtimeHealthStatus } from "../realtime/health/constants/healthStatus";

export const useRealtimeHealthStore = create((set) => ({
    streams: {},

    status: RealtimeHealthStatus.CONNECTING,

    setHeartbeat: (stream) =>
        set((state) => ({
            streams: {
                ...state.streams,
                [stream]: Date.now(),
            },
        })),

    setStatus: (status) => set({ status }),
}));